export default "/images/aef3cc09495d2cc2b2a6b565bc4f3a1c.avif";